<template>
  <v-container>
    <v-row>
      <template>
        <v-col cols="12">
          <v-card flat>
            
            <v-list v-for="(item, i) in course.latestActivities" :key="i" max-height="60px">
              <v-divider></v-divider>
              <v-list-item @click="goToAgent(item)" max-height="60px">
                <v-list-item-action>
                  <avatar
                    :username="item.name"
                    backgroundColor="#2196F3"
                    color="#fff"
                    :size="avatarSize"
                  >
                  </avatar>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                  <v-list-item-subtitle
                    ><span class="font-weight-medium font-italic">{{
                      item.verb
                    }}</span>
                    - {{ formatDate(item.timestamp) }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import Avatar from 'vue-avatar'
import { getLocalDate } from '../Constants'

export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  components: {
    Avatar
  },
  data() {
    return {
      avatarSize: 35
    }
  },
  methods: {
    goToAgent(act) {
      this.$router.push({
        path: `/courses/${this.course.id}?agentId=${act.userId}&agentName=${encodeURIComponent(act.name)}`
      })
    },
    formatDate(date) {
      return getLocalDate(date).format('lll')
    }
  }
}
</script>

<style></style>
